import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { VOUCHER_TYPE_OPTIONS } from "@/constants/voucherType";
import DiscountCreate from "./DiscountCreate";
import DiscountEdit from "./DiscountEdit";

export const discount = {
  create: DiscountCreate,
  edit: DiscountEdit,
  icon: CardGiftcardIcon,
  options: {
    label:
      VOUCHER_TYPE_OPTIONS.find((t) => t.value === "discount")?.label ||
      "Discount",
  },
};
